import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { get } from 'lodash';
import { RootState } from 'modules';
import Verification from 'components/user/signup/SignupVerification';
import { showNotification } from 'libs/utils';
import { ENotificationType } from 'enums/base.enum';
import { Tabs, Typography, Form } from 'antd';
import styled from 'styled-components';

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const MentorVerificationWrapper = styled.div`
  .steps-action {
    .ant-btn {
      width: 100%;
    }
  }
`;

const MentorVerification = () => {
  const [form] = Form.useForm();
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);

  return (
    <MentorVerificationWrapper>
      <Verification
        form={form}
        menteeId={get(currentUser, 'userid')}
        buttonText='인증 신청'
        onFinish={async () => {
          showNotification(ENotificationType.Success, '재인증 요청이 완료되었습니다. ');
        }}
      />
    </MentorVerificationWrapper>
  );
};

export default MentorVerification;
